import Unauthorized from '@package/components/Views/Unauthorized';

export default Unauthorized;
